import React from 'react';
import Charts from './Charts';

function App() {
  return (
    <div id="doc">
      <div id="body">
        <div id="load-bg"></div>
        <div className="topest">
          <div className="topest-bg">
            <nav className="topest-nav">
              <img className="topest-logo" src="./source/logo-1.png" alt="logo"/>
              {/* <ul className="right-menu">
                <li>
                  <a href="#">로그인</a>
                </li>
              </ul> */}
            </nav>
            <div className="content">
              <div className="text-wrap">
                <p className="text-top">
                  <span className="kor-txt">위조와 사기의 세기는 끝났습니다.</span>
                  <span className="eng-txt">Gone are the Centuries of Fraud.</span>
                </p>
                <p className="text-bottom">
                  <span className="kor-txt-2">
                    아무도 믿지 않고서도 <br />
                    모든 것을 믿을 수 있는 세상을 만들었습니다.
                  </span>
                  <span className="eng-txt-2">
                    Came the Trust <br />
                    out of the Trustlessness.
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="video-wrap">
            <div className="dim"></div>
            <video autoPlay loop playsInline muted>
              <source src="https://s3.ap-northeast-2.amazonaws.com/orbi.notarization/videos/1008271885-hd2.mov" />
            </video>
          </div>
        </div>
      </div>
      <div className="panel-1 panel-explain panel">
        <div className="content">
          <h2 className="paragraph-title">
            이 세상의 모든 증거를 수학 공식처럼 자명한 진리로 만듭니다.
          </h2>
          <p className="justify paragraph">
            구구단의 정답을 확인하기 위해 누군가를 믿어야 할 필요는 없습니다. <br />
            서로를 믿을 수 있든 없든 3 x 7 = 21이고 4 x 5 = 20입니다. <br />
            dDNA는 세상에 존재하는 모든 것을 수학 공식으로 치환합니다.<br />
            잔고증명서, 졸업증명서, 임대차계약서, 지불영수증, 통화내역, CCTV, 가족사진, 직접만든 음악, 영상, 문학작품, 시험문제, 일기장… 모든 것의 진본임을 구구단처럼 자명하게 만듭니다.<br />
            은행이 잔고증명서를 발행하고 dDNA에 박제하면,<br />
            대학이 졸업증명서를 발행하고 dDNA에 박제하면,<br />
            박제된 서류를 받은 자는 고작 통장잔고와 출신대학을 위조하기 위해서 몇조원의 비용을 들여야만 합니다.<br />
            이제 위조와 사기의 시대는 끝났습니다.<br />
            상대방이 제시하는 증거를 신뢰하기 위해 그 누구도 믿을 필요가 없습니다.<br />
            이것이 원본이고 진품임을 증명하기 위해, 이것을 내가 가장 먼저 만들어냈다는 것을 상대방에게 증명하기 위해, 더 이상 누구의 신뢰도 담보할 필요가 없습니다.<br />
            이제 dDNA를 통해 누구나 마치 수학 공식처럼 자명하게 그것이 진실임을 확인하고 입증할 수 있습니다.

          </p>
        </div>
      </div>

      <div className="video-1 panel-field">
        <div className="video-bg">
          <div className="video-wrap">
            <video autoPlay loop playsInline muted>
              <source src="https://s3.ap-northeast-2.amazonaws.com/orbi.notarization/videos/s2.mov" />
            </video>
          </div>
        </div>
      </div>


      <div className="panel-2 panel-explain panel">
        <div className="content">
          <h2 className="paragraph-title">
            과학수사대가 DNA로 입증을 하듯, <br />dDNA는 모든 정보를 입증가능하게 만듭니다.
          </h2>
          <p className="justify paragraph">
            1970년대에는 DNA로 범죄자를 입증한다는 개념이 없었습니다. <br />
            그렇지만 이제는 강력범죄를 입증하기 위해 과학수사대가 DNA를 활용하고, <br />법원은 그 증거를 채택합니다. <br />
            마찬가지로 dDNA 이전에는 수학으로 사기를 입증한다는 개념이 없었습니다. <br />
            그렇지만 2020년대의 법원은 모든 디지털 파일의 dDNA를 증거로 채택할 것입니다.<br />
            귀하는 단지 무엇이든 dDNA에 박제하기만 하면 됩니다.
          </p>
        </div>
      </div>

      <div className="video-2 panel-field">
        <div className="video-bg">
          <div className="video-wrap">
            <video autoPlay loop playsInline muted>
              <source src="https://s3.ap-northeast-2.amazonaws.com/orbi.notarization/videos/s3.mov" />
            </video>
          </div>
        </div>
      </div>


      <div className="panel-3 panel-explain panel">
        <div className="content">
          <h2 className="paragraph-title">
            진실의 비용을 1/1000로 낮추었습니다.
          </h2>
          <p className="justify paragraph">
            무언가가 사실임을 입증하는 데에는 막대한 비용이 듭니다. 한 번이라도 소송을 겪어본 사람은 그것을 잘 압니다. <br />
            dDNA는 인간의 신뢰에 기반한 기존의 공증 대비 사회공학적으로 1만배 이상 더 강력합니다. 공격자는 공증을 무력화하기 위해 1만배의 비용을 더 지출해야 하기 때문입니다. <br /> 
            그러면서도 그 과정에서 소모되는 비용은 기존의 1천분의 1 이하로 낮추었습니다. <br />
            귀하에게 의미있는 모든 것을 dDNA에 박제하십시오. 더 이상 공증사무소를 찾을 필요도 없고, 인증업체에 수수료를 지불할 필요도 없습니다. <br />
            개인뿐만 아니라 기업과 정부에게도 dDNA는 위조와 사기를 방지하고 신뢰비용을 절약하기 위한 가장 비용효율적인 선택입니다. 

          </p>
        </div>
      </div>

      <div className="video-3 panel-field">
        <div className="video-bg">
          <div className="video-wrap">
            <video autoPlay loop playsInline muted>
              <source src="https://s3.ap-northeast-2.amazonaws.com/orbi.notarization/videos/s4.mp4" />
            </video>
          </div>
        </div>
      </div>
      
      <div className="panel-4 panel-explain panel">
        <div className="content">
          <h2 className="paragraph-title">
            블록체인 기술은 오로지 dDNA의 등장만을 기다렸습니다.
          </h2>
          <p className="justify paragraph">
            4차산업의 총아로 스포트라이트를 받으면서도 블록체인은 지금까지 흔히 사기꾼들에게 악용되어왔습니다. 블록체인 기술을 진정으로 활용하려는 사람들보다는 다단계 범죄자들과 ICO로 한탕을 찾는 사람들이 많았습니다. <br />
            dDNA의 접근은 근본부터 다릅니다. ICO를 위해 독자적인 프라이빗 블록체인이나 토큰을 만들어내는 것은 애초에 우리 목표에 없었습니다. 이미 10년 이상 동안 축적한 막대한 엔트로피로 입증된, 지구상에서 가장 강력하고 위대한 퍼블릭 블록체인 네트워크들의 조합으로, 가장 위조저항성과 신뢰도가 높은 공증시스템을 창출해냈습니다. <br />
            공증사무소의 공증인은 수백억원의 이익이 걸려있다면 위조에 동참할 것입니다. 그러나 dDNA는 수조원의 비용을 들여도 위조할 수 없습니다. dDNA는 지구상에 존재하는 가장 강력한 디지털 공증 플랫폼입니다.
          </p>
        </div>
      </div>
      
      <div className="video-4 panel-field">
        <div className="video-bg">
          <div className="video-wrap">
            <video autoPlay loop playsInline muted>
              <source src="https://s3.ap-northeast-2.amazonaws.com/orbi.notarization/videos/s5.mov" />
            </video>
          </div>
        </div>
      </div>
      
      <div className="panel-5 panel-explain panel">
        <div className="content">
          <h2 className="paragraph-title">
            바퀴는 우리가 발명합니다. 귀하는 차를 만드십시오.
          </h2>
          <p className="justify paragraph">
            천억원대 익스포저의 펀드를 강화학습과 딥러닝 기반 트레이딩 봇으로 5년 이상 직접 운용하며 첨단 금융의 최전선을 달려온 Sindbad와 Mint Technologies의 경험으로 가장 정교하고 튼튼하며 안전한 바퀴를 만듭니다. 여러분은 바퀴를 재발명할 필요가 없습니다. 우리가 가장 저렴한 비용으로 바퀴를 제공하겠습니다. 그 위에서 훌륭한 차를 만드십시오.
          </p>
          <br />
          <div className="customer-wrap">
            <img className="customer-img" src="./source/orbi-logo.png" alt="orbi-logo"/>
          </div>
          <div className="ask-btn-wrap">
            <a href="mailto:ddna@mintec.ai">dDNA API 제휴 문의</a>
          </div>
        </div>
      </div>
      
      <div className="video-5 panel-field">
        <div className="video-bg">
          <div className="video-wrap">
            <video autoPlay loop playsInline muted>
              <source src="https://s3.ap-northeast-2.amazonaws.com/orbi.notarization/videos/s6.mov" />
            </video>
          </div>
        </div>
      </div>
      
      <div className="panel-6 panel-explain panel">
        <div className="content">
          <h2 className="paragraph-title">
            dDNA의 원리
          </h2>
          <p className="justify paragraph">
            <b>dDNA 값을 찾아내는 과정</b> <br />
            원본 파일이 동일하면 지구 반대편에서 계산해도, 100년 후에 계산해도 DNA 값은 완전히 동일하며 영원히 변하지 않습니다. <a className="plus-link" href="/">[더 자세히 알아보기]</a> <br /> <br />

            <b>dDNA의 위조저항성</b> <br />
            그렇지만 수천 페이지의 원본 중 단 한글자만 달라져도, 수천만 픽셀의 이미지 중 점 하나의 색깔만 달라져도 DNA는 이전과 완전히 다른 값으로 돌변합니다. <a className="plus-link" href="/">[더 자세히 알아보기]</a> <br /> <br />

            <b>블록체인의 위조저항성</b> <br />
            블록체인의 중간에 기록된 값은 단 한 글자만 바뀌어도, 장부를 함께 기록하는 수천 명이 즉시 동시에 위조 여부를 알아챌 수 있습니다. 만약 체인 중간의 값 하나를 위조하려면 그 이후 모든 체인을 위조해야 하고, 함께 그 값을 기록하는 수천 명의 장부를 동시에 위조해야 합니다. <a className="plus-link" href="/">[더 자세히 알아보기]</a> <br /> <br />

            <b>블록체인에 박제된 dDNA의 위조저항성</b> <br />
            우리는 DNA를 세계에서 가장 오래되고, 가장 거대하며, 가장 긴 블록체인에 기록합니다. 이 퍼블릭 블록체인에 기록된 DNA를 위조하려면 수조원의 비용을 들여야 합니다. <a className="plus-link" href="/">[더 자세히 알아보기]</a>
          </p>
        </div>
      </div>
      
      <div className="panel-7 panel-explain panel">
        <div className="content">
          <h2 className="paragraph-title">
            dDNA Cumulative Transactions
          </h2>
          <div className="img-wrap">
            <Charts />
          </div>
        </div>
      </div>
      
      <div className="panel-8 panel-explain panel">
        <div className="content">
          <h2>
            현재 시점에서 dDNA가 채택한 블록체인에<br />
            1일 간 "51% 공격"을 하기 위해 소모되는 비용
          </h2>
          <h3>
            BTC 블록체인 : <span>35,096,712,790</span> 원
          </h3>
          <h3>
            ETH 블록체인 : <span>35,994,057,000</span> 원
          </h3>
          <h3>
            ETC 블록체인 : <span>854,073,800</span> 원
          </h3>
          <h3>
            BCH 블록체인 : <span>648,065,350</span> 원
          </h3>
            <h3>
            BSV 블록체인 : <span>208,669,540</span> 원
          </h3>
          <p className="justify paragraph content-txt">
            51% 공격을 받고 있는 동안 해당 블록체인에 새로 박제되는 정보는 차후 폐기되거나 변조될 가능성이 있습니다. <br /><br />
            51% 공격을 받지 않은 상태로 정상적으로 운영된 블록체인에 박제된 상태로 1시간 이상 경과한 기록을 위조하는 것은 해당 블록체인의 모든 채굴장을 확보, 폐쇄하지 않는 이상 불가능합니다. BTC 블록체인의 경우 12년 이상 운영되는 동안 51% 공격을 받지 않았습니다. 다른 블록체인들도 수 년 이상 정상적으로 운영되어왔으며, 블록체인의 수 시간전 내지는 수 일 전 기록을 위조하는데 소모되는 비용을 굳이 이론적으로 계산하려면, 해당 블록체인 그 자체의 가치(시가총액)에 비용을 견줄 수 있습니다. BTC의 시가총액은 약 1,000조원입니다.
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
